<template>
  <v-container>
    <v-row class="ma-1">
      <v-spacer />
    </v-row>
    <v-card class="card" dark>
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        class="ml-12 mr-12 mt-8"
      >
        <v-row>
          <v-col cols="1" />
          <v-col cols="4">
            <v-text-field
              v-model="schedule.title"
              :counter="30"
              :rules="nameRules"
              label="Title"
              required
            ></v-text-field>
            <v-menu
              ref="showDate"
              v-model="showDate"
              :close-on-content-click="false"
              :return-value.sync="schedule.date"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="schedule.date"
                  label="Session Date"
                  prepend-icon="mdi-calendar"
                  :rules="dateRules"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="schedule.date"
                no-title
                scrollable
                :min="schedulePickerMin"
                :open-date="new Date()"
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="showDate = false">
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.showDate.save(schedule.date)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
            <template>
              <v-text-field
                v-model="schedule.time"
                label="Session Time"
                :type="timeFieldType"
                clearable
                v-bind="attrs"
                v-on="on"
                :rules="[validateTime]"
                ref="timePicker"
                prepend-icon="mdi-clock"
                placeholder="HH:MM AM/PM"
                @focus="timeFieldType = 'time'"
                @input="$refs.form.validate()"
              />
              <v-text-field
                v-model="schedule.endTime"
                label="End Time"
                type="time"
                clearable
                prepend-icon="mdi-clock"
                :rules="[validateEndTime]"
                @input="$refs.form.validate()"
              />
            </template>
            <v-text-field
              v-model="schedule.gameDuration"
              v-if="this.schedule.type == 'FIXED_ODDS_BINGO'"
              type="number"
              min="1"
              max="120"
              label="Game Interval Duration (mins)"
              :rules="gameDurationRules"
            ></v-text-field>
            <v-select
              class="scheduleProduct"
              v-model="selectedTemplates"
              @change="updatePlayableGames(selectedTemplates)"
              :items="filterTemplates"
              item-value="id"
              label="Products To Include"
              clearable
              multiple
              :rules="productRules"
              :disabled="!schedule.type"
              max
            >
              <template v-slot:selection="{ item }">
                <v-chip text-color="white" :color="determineChipColour(item)">{{
                  item.title
                }}</v-chip>
              </template>
              <template v-slot:item="{ item, attrs, on }">
                <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                  <v-list-item-action>
                    <v-checkbox :input-value="active"></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-row no-gutters align="center">
                        <span>{{ item.title }}</span>
                        <v-spacer></v-spacer>
                        <v-chip
                          v-if="item.flyer"
                          text-color="white"
                          color="success"
                          small
                          class="ml-2"
                          >Flyer</v-chip
                        >
                        <v-chip
                          v-if="item.isPackage"
                          text-color="white"
                          color="success"
                          small
                          class="ml-2"
                          >Package</v-chip
                        >
                        <span v-else>{{ item.pages }} Pages</span>
                        <img
                          contain
                          class="logo"
                          :src="'data:image/jpeg;base64,' + item.logo"
                        />
                      </v-row>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-select>
          </v-col>
          <v-col cols="1" />
          <v-col cols="4">
            <v-select
              v-model="schedule.type"
              :items="gameTypes"
              :rules="[(v) => !!v || 'Type of Game is required']"
              label="Type of Game"
              required
            ></v-select>
            <v-radio-group
              v-model="schedule.gameMode"
              :rules="[(v) => !!v || 'Please select a game mode']"
              label="Game Mode"
              row
            >
              <v-radio label="Active" value="ACTIVE"></v-radio>
              <v-radio label="Passive" value="PASSIVE"></v-radio>
            </v-radio-group>
            <v-menu
              v-if="this.schedule.type == 'FIXED_ODDS_BINGO'"
              ref="showByDate"
              v-model="showEndByDate"
              :close-on-content-click="false"
              :return-value.sync="schedule.endByDate"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="schedule.endByDate"
                  label="End By Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  :rules="endDateRules"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="schedule.endByDate"
                no-title
                scrollable
                :min="schedulePickerMin"
                :open-date="new Date()"
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="showEndByDate = false">
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.showByDate.save(schedule.endByDate)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
            <v-text-field
              v-model="schedule.callDuration"
              v-if="this.schedule.type == 'FIXED_ODDS_BINGO'"
              type="number"
              min="4"
              max="12"
              label="Call Duration (seconds)"
              :rules="callDurationRules"
            ></v-text-field>
            <v-row>
              <v-col cols="6">
                <v-checkbox
                  v-model="schedule.autoStart"
                  label="Auto Start"
                ></v-checkbox>
              </v-col>
              <v-col cols="6">
                <v-checkbox
                  v-model="schedule.oneOffGame"
                  label="One Off Game"
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-text-field
              v-model="schedule.verificationWaitMinutes"
              type="number"
              min="0"
              max="1440"
              label="Verification Wait Period (minutes)"
              :rules="verificationWaitRules"
              hint="Time to wait for verification before proceeding"
              persistent-hint
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="this.schedule.type != 'LOTTO'">
          <v-col cols="1" />
          <v-col cols="10">
            <v-data-table
              light
              v-show="playableGames.length > 0"
              :headers="headers"
              :items="playableGames"
              item-key="tableId"
              :show-select="false"
              :disable-pagination="true"
              :hide-default-footer="true"
              class="page__table"
            >
              <template v-slot:body="props">
                <draggable :list="props.items" tag="tbody" @end="endDrag">
                  <tr v-for="(item, index) in props.items" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>
                      <div
                        class="square"
                        :style="{ background: item.colour }"
                      />
                    </td>
                    <td>{{ item.description }}</td>
                    <td><v-icon>mdi-reorder-horizontal </v-icon></td>
                  </tr>
                </draggable>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <v-row class="mb-2">
          <v-col class="text-right pt-3">
            <v-btn class="mr-4 accent" @click="reset"> Clear </v-btn>

            <v-btn
              color="primary main_button"
              class="mr-4"
              @click="validateBeforeSubmit"
              :disabled="submitting"
              :loading="submitting"
            >
              Add
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card>

    <!-- Confirmation Dialog -->
    <v-dialog v-model="confirmDialog" max-width="450px">
      <v-card class="confirmationPopup">
        <img contain class="attentionlogo" src="../../assets/sureImg.svg" />
        <v-card-title class="headlinePopup">Are you sure?</v-card-title>
        <v-card-text class="popupContent">
          You want to proceed based on the duration between the
          <span class="purpletext"
            >Start Time: {{ schedule.time }}, Start Date:
            {{ schedule.date }}</span
          >
          and
          <span class="purpletext"
            >End Time: {{ schedule.endTime }}, End Date:
            {{ schedule.endByDate || schedule.date }}</span
          >, this will create
          <span class="purpletext">{{ calculateSessionCount() }} sessions</span>
          using the defined interval.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="cancelBtnPopup" text @click="confirmDialog = false"
            >Cancel</v-btn
          >
          <v-btn class="proceedBtnPopup" text @click="submit">PROCEED</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Draggable from "vuedraggable";
import { convertToUTC } from "../../utils/convertToUTC";
export default {
  components: {
    Draggable,
  },
  name: "CreateSchedule",
  created() {
    this.fetchTemplates();
  },
  data: () => ({
    valid: false,
    submitting: false,
    confirmDialog: false,
    schedule: {
      title: "",
      sessionType: "EVENING",
      date: "",
      endByDate: "",
      time: "",
      callDuration: 0,
      gameDuration: 0,
      gameMode: null,
      endTime: "",
      autoStart: false,
      oneOffGame: false,
      verificationWaitMinutes: 0,
    },
    showDate: false,
    showEndByDate: false,
    showTime: false,
    schedulePicker: null,
    schedulePickerMin: new Date().toISOString().substr(0, 10),
    selectedSchedule: null,
    sessionTypes: ["Morning", "Afternoon", "Evening", "Time Specific"],
    gameTypes: ["BINGO", "LOTTO", "FIXED_ODDS_BINGO"],
    nameRules: [
      (v) => !!v || "Name is required",
      (v) => (v && v.length <= 30) || "Name must be less than 30 characters",
    ],
    dateRules: [(v) => !!v || "Please select a date"],
    endDateRules: [(v) => !!v || "Please select a date"],
    verificationWaitRules: [
      (v) =>
        (v !== null && v !== undefined && v !== "") ||
        "Verification Wait Period required",
      (v) => v >= 0 || "Value must not be a negative value",
      (v) => v <= 1440 || "Value cannot exceed 1440 minutes (24 hours)",
      (v) => Number.isInteger(Number(v)) || "Value must be a whole number",
    ],

    productRules: [
      (v) => (!!v && v.length > 0) || "Schedules require at least one product",
    ],
    callDurationRules: [
      (v) => !!v || "Call Duration is required",
      (v) => v >= 1 || "Call Duration must be at least 4 seconds",
      (v) => v <= 12 || "Call Duration cannot exceed 12 seconds",
    ],

    selectedTemplates: [],
    gameOrder: [],
    headers: [
      { text: "Order", sortable: false, width: "10%" },
      { text: "Colour", value: "colour", sortable: false, width: "10%" },
      {
        text: "Description",
        value: "description",
        sortable: false,
        width: "70%",
      },
      { text: "Reorder", sortable: false, width: "10%" },
    ],
    gameDurationRules: [
      (v) => !!v || "Game Interval is required",
      (v) => v >= 1 || "Game duration must be at least 15 minutes",
      (v) => v <= 120 || "Game duration cannot exceed 120 minutes",
    ],
    timeFieldType: "text",
  }),
  mounted() {
    this.setCurrentPage("Create new Schedule");
  },
  computed: {
    ...mapGetters(["getTemplateList"]),
    showTimePicker() {
      return this.schedule.sessionType == "Time Specific" ? true : false;
    },
    filterTemplates() {
      let templates = this.getTemplateList.filter(
        (template) => template.type == this.schedule.type
      );
      return templates;
    },
    playableGames: {
      get: function() {
        let playableGames = [];
        for (let templateId of this.selectedTemplates) {
          let template = this.getTemplateList.find((t) => t.id === templateId);
          if (template) {
            playableGames = playableGames.concat(
              this.createGameTableItems(template)
            );
          }
        }
        return playableGames;
      },
    },
  },
  methods: {
    ...mapActions(["fetchTemplates", "saveSchedule", "setCurrentPage"]),
    calculateSessionCount() {
      if (this.schedule.oneOffGame) {
        return 1;
      }
      if (
        !this.schedule.time ||
        !this.schedule.endTime ||
        !this.schedule.date ||
        !this.schedule.gameDuration ||
        this.schedule.gameDuration <= 0
      ) {
        return 0;
      }
      const [startHour, startMinute] = this.schedule.time
        .split(":")
        .map(Number);
      const [endHour, endMinute] = this.schedule.endTime.split(":").map(Number);

      let windowMinutes =
        endHour * 60 + endMinute - (startHour * 60 + startMinute);
      if (windowMinutes <= 0) {
        windowMinutes += 24 * 60;
      }

      const sessionsPerDay = Math.ceil(
        windowMinutes / this.schedule.gameDuration
      );
      const startDate = new Date(this.schedule.date);
      const endDate = new Date(this.schedule.endByDate || this.schedule.date);
      const days = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;
      return sessionsPerDay * days;
    },
    validateTime(value) {
      if (!value) return "Time is required";

      if (!this.schedule.date) return true;

      const selectedDateTime = new Date(`${this.schedule.date}T${value}`);
      const currentTime = new Date();

      currentTime.setMinutes(currentTime.getMinutes() + 2);

      if (selectedDateTime < currentTime) {
        return "Selected time must be at least 2 minutes ahead of the current time";
      }

      return true;
    },
    validateEndTime(value) {
      if (!this.schedule.time) return "Please enter a start time first";
      if (!value) return "End time is required";

      const startTime = this.schedule.time.split(":").map(Number);
      const endTime = value.split(":").map(Number);

      if (startTime.length < 2 || endTime.length < 2)
        return "Invalid time format";

      const startDateTime = new Date(
        `${this.schedule.date}T${this.schedule.time}`
      );
      const endDateTime = new Date(
        `${this.schedule.endByDate || this.schedule.date}T${value}`
      );

      if (endDateTime <= startDateTime) {
        return "End time must be after start time";
      }

      return true;
    },
    endDrag(event) {
      const movedItem = this.gameOrder.splice(event.oldIndex, 1)[0];
      this.gameOrder.splice(event.newIndex, 0, movedItem);
    },
    validateBeforeSubmit() {
      if (this.$refs.form.validate()) {
        this.confirmDialog = true;
      }
    },
    async submit() {
      if (this.submitting) return;
      this.submitting = true;
      this.confirmDialog = false;

      if (this.schedule.time && this.schedule.endTime) {
        const start = this.schedule.time.split(":").map(Number);
        const end = this.schedule.endTime.split(":").map(Number);

        const startMinutes = start[0] * 60 + start[1];
        const endMinutes = end[0] * 60 + end[1];

        if (endMinutes <= startMinutes) {
          this.$store.dispatch(
            "showError",
            "End time must be after start time"
          );
          return;
        }
      }
      const scheduleToSave = { ...this.schedule };

      scheduleToSave.time = convertToUTC(
        this.schedule.date,
        this.schedule.time
      );
      scheduleToSave.endTime = convertToUTC(
        this.schedule.endByDate,
        this.schedule.endTime
      );
      // scheduleToSave.time = this.schedule.time;
      // scheduleToSave.endTime = this.schedule.endTime;
      scheduleToSave.gameOrder = [];
      for (let i = 0; i < this.gameOrder.length; i++) {
        scheduleToSave.gameOrder.push({
          colour: {
            id: this.gameOrder[i].id,
            attributeName: this.gameOrder[i].name,
            attributeValue: this.gameOrder[i].colour,
            attributeType: this.gameOrder[i].type,
          },
          templateId: this.gameOrder[i].templateId,
        });
      }
      if (this.schedule.type == "LOTTO") {
        scheduleToSave.gameOrder.push({
          // colour: {
          //   id: this.gameOrder[i].id,
          //   attributeName: this.gameOrder[i].name,
          //   attributeValue: this.gameOrder[i].colour,
          //   attributeType: this.gameOrder[i].type,
          // },
          templateId: this.selectedTemplates[0],
        });
      }
      scheduleToSave.selectedTemplates = this.selectedTemplates;
      scheduleToSave.autoStart = this.schedule.autoStart;
      this.saveSchedule(scheduleToSave);
    },
    updatePlayableGames(selectedTemplates) {
      let playableGames = [];
      for (let templateId of selectedTemplates) {
        let template = this.getTemplateList.find((t) => t.id === templateId);
        if (template) {
          playableGames = playableGames.concat(
            this.createGameTableItems(template)
          );
        }
      }
      this.gameOrder = playableGames;
    },
    determineChipColour(item) {
      if (item.flyer) {
        return item.gameColours[0].attributeValue;
      } else {
        if (item.pages == 6) {
          return "red";
        } else if (item.pages == 3) {
          return "green";
        } else {
          return "purple";
        }
      }
    },
    createGameTableItems(template) {
      let gameTableItems = [];

      for (var i = 0; i < template.gameColours.length; i++) {
        gameTableItems.push({
          tableId: template.id + i,
          templateId: template.id,
          name: template.gameColours[i].attributeName.toLowerCase(),
          id: template.gameColours[i].id,
          colour: template.gameColours[i].attributeValue,
          description: template.title + " - Game " + (i + 1),
          type: template.gameColours[i].attributeType,
        });
      }
      return gameTableItems;
    },
    reset() {
      this.$refs.form.reset();
    },
  },
  watch: {
    "schedule.date": {
      handler(newDate) {
        if (newDate && this.schedule.time) {
          this.$refs.form.validate();
        }
      },
      immediate: false,
    },
    "schedule.time": {
      handler() {
        if (this.schedule.endTime) {
          this.$refs.form.validate();
        }
      },
      immediate: false,
    },
    "schedule.endByDate": {
      handler() {
        if (this.schedule.endTime) {
          this.$refs.form.validate();
        }
      },
      immediate: false,
    },
  },
};
</script>

<style scoped>
.logo {
  max-height: 24px;
}

.square {
  width: 2vw;
  height: 2vw;
  min-width: 30px;
  min-height: 30px;
  border: rgb(73, 73, 73);
  border-style: solid;
  border-radius: 2px;
}
.purpletext {
  color: #2f3693;
  font-family: "PT Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 21px;
}
.cancelBtnPopup {
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 1.25px;
  text-transform: uppercase;
  display: flex;
  width: 187.5px;
  height: 36px;
  padding: 9.11px 65.25px 8.89px 67.25px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 4px;
  background: #fcbf49;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}
.proceedBtnPopup {
  color: #fff;
  text-align: center;
  font-family: "PT Sans";
  font-size: 14px;
  font-weight: 400;
  text-transform: uppercase;
  display: flex;
  width: 187.5px;
  height: 36px;
  padding: 9.11px 59.25px 8.89px 61.25px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 4px;
  background: #323887;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}
.popupContent {
  color: #333;
  text-align: center;
  font-family: "PT Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
}
.headlinePopup {
  color: #282828;
  text-align: center !important;
  font-family: "PT Sans";
  font-size: 32px !important;
  font-style: normal;
  font-weight: 700 !important;
  line-height: 18px; /* 56.25% */
  text-transform: capitalize;
  justify-content: center;
}
.confirmationPopup {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 0px;
}
</style>

<style>
input::-webkit-calendar-picker-indicator {
  display: none;
}

@media screen and (max-width: 1400px) {
  .scheduleProduct .v-menu__content {
    top: 540px !important;
  }
}
</style>
